/**
 * Co-Pilot Toggle Button Component
 * Switches between Public Chat and Co-Pilot modes
 */

import React from 'react';
import { MessageSquare, Bot } from 'lucide-react';
import { cn } from '../../lib/utils';

interface CoPilotToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
}

const CoPilotToggle: React.FC<CoPilotToggleProps> = ({ enabled, onChange }) => {
  return (
    <div className="flex h-full">
      <button
        onClick={() => onChange(false)}
        title="Public customer-facing chat"
        className={cn(
          "flex items-center gap-1.5 px-3 py-2 text-sm border-b-2 transition-all duration-150 outline-none",
          !enabled
            ? "border-primary text-foreground font-medium"
            : "border-transparent text-muted-foreground hover:text-foreground hover:border-border/60"
        )}
      >
        <MessageSquare className="h-3.5 w-3.5" />
        Public Chat
      </button>
      <button
        onClick={() => onChange(true)}
        title="Private AI assistant for agents"
        className={cn(
          "flex items-center gap-1.5 px-3 py-2 text-sm border-b-2 transition-all duration-150 outline-none",
          enabled
            ? "border-primary text-foreground font-medium"
            : "border-transparent text-muted-foreground hover:text-foreground hover:border-border/60"
        )}
      >
        <Bot className="h-3.5 w-3.5" />
        Co-Pilot
      </button>
    </div>
  );
};

export default CoPilotToggle;
